import { render, staticRenderFns } from "./AepCopayBlock.vue?vue&type=template&id=0c5cd1df&lang=pug"
import script from "./AepCopayBlock.vue?vue&type=script&lang=js"
export * from "./AepCopayBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DrugsMonthlyByDrug: require('/home/docker/code/frontend/components/DrugsMonthlyByDrug.vue').default})
